module.exports = __webpack_public_path__ + "img/logo_distri_jantes.51f15c0f.svg";